export default __webpack_public_path__ + "static/media/avatars.51a43fcb.png";